import { axiosInstance } from "../config/axios";

const handlerEnabled = true;
const endpoint = "brand/";

export const Create = async (params) => {
	try {
		const res = await axiosInstance.post(endpoint, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const UpdateBrand = async (params, id) => {
	try {
		const res = await axiosInstance.put(`${endpoint}${id}/`, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getAllBrand = async (row, page = 1, filter) => {
	try {
		const res = await axiosInstance.get(endpoint, {
			params: { ...filter, page_size: row, page: page },
			handlerEnabled,
		});

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const downloadExcel = async (id) => {
	try {
		const response = await axiosInstance.get(`/products_via_excel/`, {
			params: { id: id },
			responseType: "blob", // Important for downloading files
		});

		// Create a download link
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const a = document.createElement("a");
		a.href = url;
		a.download = "product_template.xlsx"; // Filename
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		return { success: true };
	} catch (error) {
		console.error("Download failed:", error);
		return { success: false };
	}
};

export const uploadExcel = async (formData) => {
	try {
		// ✅ Ensure correct headers for file upload
		const response = await axiosInstance.post(
			"/products_via_excel/",
			formData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		);

		return { success: true, data: response.data }; // ✅ Ensure success response format
	} catch (error) {
		console.error("Upload error:", error);

		return {
			success: false,
			error: error.response?.data || "Upload failed",
		};
	}
};
